import { render } from "./LocumJobseekerWelcome.vue?vue&type=template&id=65e822c9"
import script from "./LocumJobseekerWelcome.vue?vue&type=script&lang=js"
export * from "./LocumJobseekerWelcome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__